module.exports = __webpack_public_path__ + "static/img/dsh1.7ac7dd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/readingParty/dsh1.png
// module id = O71w
// module chunks = 0